import sprite from "../../../assets/icons.svg";
import spriteNative from "../assets/nativeIcons/icons.svg";
export const Dock = ({ dockAlign, closeDeviceDetails, setDockAlign, setPopup }) => {
  const renderHeaderItems = ["split-down", "split-left", "split-right", "pop-out", "cross"].map(
    (item, index) => {
      return (
        item !== dockAlign && (
          <>
            <div
              onClick={() => {
                item === "cross" && closeDeviceDetails();
                item === "pop-out" && setPopup();
                setDockAlign(item);
              }}
              className="details-block_actions_item"
              key={index}
            >
              <svg className="icon cross">
                <use href={`${item === "cross" ? sprite : spriteNative}#${item}`}></use>
              </svg>
            </div>
          </>
        )
      );
    }
  );
};
